export default class {
    /**
     * Returns boolean whether input is valid float or not.
     *
     * @param input
     * @param separator
     * @param decimals
     * @param beforeComma
     */
    isFloat (input, separator = '.,', decimals = 2, beforeComma = 4) {
        const rules = new RegExp(`^([0-9]{1,${beforeComma}}[${separator}]{0,1}[0-9]{0,${decimals}})$`);
        return rules.test(input);
    }

    /**
     * Custom method because IE 11 does not support Number.isInteger
     * See more at: https://stackoverflow.com/questions/31720269/internet-explorer-11-object-doesnt-support-property-or-method-isinteger
     *
     * @param value
     * @returns {boolean}
     */
    isInteger (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/number/index.js